var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree',{attrs:{"data":_vm.treeData,"options":_vm.treeOptions},on:{"node:selected":_vm.onNodeSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }